<div class="column-sort-container">
   <mat-form-field class="column-select">
      <mat-label>Column</mat-label>
      <mat-select [value]="selectedColumn" (selectionChange)="onColumnChanged($event.value)">
         @for (column of columns; track column) {
         <mat-option [value]="column">
            {{ column.displayName }}
         </mat-option>
         }
      </mat-select>
   </mat-form-field>

   <mat-form-field class="direction-select">
      <mat-label>Sort Order</mat-label>
      <mat-select [value]="selectedDirection" (selectionChange)="onDirectionChanged($event.value)">
         @for (direction of directions | keyvalue; track direction) {
         <mat-option [value]="direction.value">
            {{ direction.value }}
         </mat-option>
         }
      </mat-select>
   </mat-form-field>
</div>
